import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/routes";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
ApiService.setHeader();
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.config.globalProperties.$currency = process.env.VUE_APP_CURRENCY_SYMBOL;

app.mount("#app");
